import { faCheckSquare } from "@fortawesome/free-solid-svg-icons/faCheckSquare";
import { faSquare } from "@fortawesome/free-solid-svg-icons/faSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputNumerico } from "app/components/inputs/InputNumerico";
import { InsumoOrdemProducao } from "app/types/OrdemProducao";
import globalMU from "globalMU";
import React, { useEffect, useState } from "react"


const estilosBotoes = require("../../../estilos/botoes.module.scss").default;
const estiloTabela = require('../../../estilos/tabelas.module.scss').default

export type InclusaoInsumoProps = {
    selecionarTodos: boolean
    insumos: InsumoOrdemProducao[]
    insumosSelecionados: InsumoOrdemProducao[]
    listaQuantidade: { codigo: string, quantidade: number }[]
    onOk: () => void
    onSelecionarInsumo: (insumoSelecioando: InsumoOrdemProducao) => void
    onSelecionaTodos: () => void
    onAlterarQuantidade: (quantidade: number, CodigoProdutoInsumo: string, quantidadeOriginal: number) => void
}

export const InclusaoInsumo = (props: InclusaoInsumoProps) => {

    const [listaQuantidade, setListaQuantidade] = useState<{ codigo: string, quantidade: number }[]>()

    const onConfirmarAlteracaoQuantidade = (quantidade: number, codigo: string, quantidadeOriginal: number) => {

        const novaListaQuantidade = [...listaQuantidade];
        const index = novaListaQuantidade.findIndex(item => item.codigo === codigo);
        if (index !== -1) {
            novaListaQuantidade[index] = { codigo, quantidade };
        } else {
            novaListaQuantidade.push({ codigo, quantidade });
        }
        setListaQuantidade(novaListaQuantidade);
        props.onAlterarQuantidade(quantidade, codigo, quantidadeOriginal)
    }

    const headerTabela = () => {
        const mapHeader = ["Código", "Referência", "Descrição", "Quantidade Mínima", "Quantidade Máxima", "Qunatidade"]

        return mapHeader.map((nome) => <th key={nome} className={`_table-cell`}>{nome}</th>)
    }

    useEffect(() => {
        setListaQuantidade(props.listaQuantidade)
    }, [props.listaQuantidade])

    const bodyTabela = (insumo: InsumoOrdemProducao) => {

        const inputQuantidade = <InputNumerico
            valor={listaQuantidade?.find(item => item.codigo === insumo?.CodigoProdutoInsumo)?.quantidade}
            numeroCasasDecimais={3}
            onValorModificado={(valor) => onConfirmarAlteracaoQuantidade(valor, insumo?.CodigoProdutoInsumo, insumo.QuantidadeFormula)}
            selecionaValorOnFocus={true}
            classesInput={["_w-full"]}
        />

        const mapHeader = [insumo.CodigoProdutoInsumo, insumo.CodigoInterno,
        globalMU.isNotNullOrEmpty(insumo.DescricaoLonga) ? insumo.Descricao : insumo.DescricaoLonga,
        globalMU.formatarValorNumerico(insumo.QuantidadeMinima * insumo.QuantidadeProdutoFabricacaoPropria, 3, false), globalMU.formatarValorNumerico(insumo.QuantidadeMaxima * insumo.QuantidadeProdutoFabricacaoPropria, 3, false), inputQuantidade]

        return mapHeader.map((nome, index) => <td key={index} className={`_table-cell`}>{nome}</td>)
    }

    return (
        <>
            <div className="_my-4">
                <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoIcone}`}
                    onClick={() => props.onSelecionaTodos()}
                >
                    <FontAwesomeIcon icon={props.selecionarTodos ? faCheckSquare : faSquare} color={"#3c8ac9"} className="_text-2xl" />
                    Selecionar todos
                </button>
            </div>

            <div className="_my-4">
                <table className={`_table _w-full _border-collapse ${estiloTabela.tabela}`}>
                    <thead className="_table-header-group">
                        <tr className="_table-row">
                            {headerTabela()}
                        </tr>
                    </thead>

                    <tbody className="_table-row-group">
                        {props.insumos?.map((dado) => (
                            <tr key={dado.CodigoProdutoInsumo} className={`_table-row ${estiloTabela.linhaClicavel} ${props.insumosSelecionados.includes(dado) && estiloTabela.linhaSelecionada}`}
                                onClick={() => props.onSelecionarInsumo(dado)}>
                                {bodyTabela(dado)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="_my-4">
                <div className="_justify-between">
                    <div className="_my-4">
                        <button className={`_flex _my-2 no-global-button ${estilosBotoes.botaoPrimario}`}
                            disabled={listaQuantidade?.filter(x => x.quantidade > 0)?.length <= 0 || props.insumosSelecionados?.length <= 0}
                            onClick={() => { props.onOk() }}
                        >
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}